import React from 'react';
import {View} from 'react-native';
import {IStateProps} from './model';
import {useStyles} from '../../../../../shared/hooks/styles';
import {ApplicationsItemStatus} from '../itemStatus';
import {stylePatterns} from '../../../../../shared/theme/patterns';
import {useIsDesktop} from '../../../../../shared/hooks/useIsDesktop';
import {Text} from '../../../../../shared/components/text';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {DeviceSize} from '../../../../../shared/theme/helpers';

export default ({subjects, historyTable, statusId, statusName, application}: IStateProps) => {
  const isDesktop = useIsDesktop();
  const styles = useStyles(({theme, mediaOnly}) => ({
    desktopTitle: {
      ...theme.fonts.h2,
    },
    statusWrap: {
      display: 'flex',
      flexDirection: 'row',
      ...mediaOnly(
        DeviceSize.desktop,
        {justifyContent: 'space-between', alignItems: 'center'},
        {justifyContent: 'flex-end'},
      ),
    },
    subjectWrap: {
      paddingTop: isDesktop ? 30 : 20,
    },
    subjectItem: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      paddingBottom: 20,
    },
    subjectItemLabel: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.body, minWidth: 120},
        {...theme.fonts.bodySmallLight, minWidth: 100},
      ),
      color: theme.applications.labelColor,
    },
    subjectItemValue: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.h5Light, paddingLeft: 24, textAlign: 'left'},
        {...theme.fonts.body, paddingLeft: 10, textAlign: 'right'},
      ),
      flexShrink: 1,
      flexGrow: 1,
      overflow: 'hidden',
    },
    historyWrap: isDesktop
      ? {
          paddingTop: isDesktop ? 30 : 20,
        }
      : {
          paddingVertical: 13,
          marginHorizontal: isDesktop ? -24 : -35,
          paddingHorizontal: isDesktop ? 24 : 35,
          backgroundColor: theme.applications.mobileHistoryStatusBg,
        },
    historyTitle: isDesktop ? theme.fonts.h3 : theme.fonts.h6Light,
    historyTableWrap: {
      paddingTop: isDesktop ? 16 : 13,
    },
    historyTableHeader: {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 4,
    },
    historyTableHeaderItem: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
      flex: 1,
      color: theme.applications.textCaptionColor,
    },
    historyTableContent: {
      ...stylePatterns.flexCenterVertical,
      minHeight: 50,
      borderColor: theme.applications.tableRowSeparatorColor,
      borderTopWidth: 1,
    },
    historyTableContentItem: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h6Light, theme.fonts.bodySmallLight),
      flex: 1,
      paddingRight: 10,
    },
    historyTableRow: isDesktop
      ? {}
      : {
          paddingLeft: 4,
          marginLeft: -4,
        },
  }));

  return (
    <View>
      {isDesktop && (
        <View style={styles.statusWrap}>
          <Text style={styles.desktopTitle}>Заявление</Text>
          <ApplicationsItemStatus statusId={statusId} statusName={statusName} />
        </View>
      )}
      <LoadableContent loading={!application}>
        {!isDesktop && (
          <View style={styles.statusWrap}>
            <ApplicationsItemStatus statusId={statusId} statusName={statusName} />
          </View>
        )}
        <View style={styles.subjectWrap} testID='application-subjects'>
          {subjects.map(({label, value}, i) => (
            <View style={styles.subjectItem} key={i} testID={`application-subject-${i}`}>
              <Text style={styles.subjectItemLabel} testID={`application-subject-${i}-label`}>
                {label}:
              </Text>
              <Text style={styles.subjectItemValue} testID={`application-subject-${i}-value`}>
                {value}
              </Text>
            </View>
          ))}
        </View>
        <View style={styles.historyWrap} testID='application-history'>
          <Text style={styles.historyTitle} testID='application-history--title'>
            История рассмотрения
          </Text>
          <View style={styles.historyTableWrap}>
            {historyTable.map((row, rowIndex) => (
              <View
                style={[
                  rowIndex === 0 ? styles.historyTableHeader : styles.historyTableContent,
                  styles.historyTableRow,
                ]}
                key={rowIndex}
                testID={`application-history-item-${rowIndex}`}>
                {row.map((value, valueIndex) => (
                  <Text
                    style={rowIndex === 0 ? styles.historyTableHeaderItem : styles.historyTableContentItem}
                    key={valueIndex}
                    testID={`application-history-item-${rowIndex}--body-${valueIndex}`}>
                    {value}
                  </Text>
                ))}
              </View>
            ))}
          </View>
        </View>
      </LoadableContent>
    </View>
  );
};
